<template>
<v-text-field type="text" v-model="internalValue" @keydown="isNumber" @input="sanitizeInput" :rules="computedRules" :required="required" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
export default {
  name: 'MyNumber',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    allowNegative: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      internalValue: this.value,
    }
  },
  computed: {
    computedRules() {
      const baseRules = [...this.rules]

      if (this.required) {
        baseRules.unshift(v => (v !== null && v !== '' && v !== undefined) || 'الزامی')
      }

      return baseRules
    }
  },
  watch: {
    value(val) {
      this.internalValue = val
    },
    internalValue(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    isNumber(e) {
      const allowedKeys = [
        'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', 'End'
      ]
      if (allowedKeys.includes(e.key)) return

      if (e.key === '-' && e.target.value === '' && this.allowNegative) {
        return
      }

      if (!/^[0-9]$/.test(e.key)) {
        e.preventDefault()
      }
    },
    sanitizeInput() {
      let val = String(this.internalValue ?? '')

      val = val.replace(/[^0-9-]/g, '')

      if (!this.allowNegative) {
        val = val.replace(/-/g, '')
      } else {
        val = val.replace(/(?!^)-/g, '')
      }

      this.internalValue = val
    }
  },
}
</script>
